import { Injectable, Type } from '@angular/core';
import {
  ButtonsComponent,
  CartTotalStepComponent,
  CheckoutStepComponent,
  EmailRecipientComponent
} from 'gung-standard';
import {
  AssignJeevesDefaultsComponent,
  AssignOrderRowsJeevesComponent,
  DeliveryLocationsJeevesComponent,
  JeevesCheckoutConfigService,
  OrderTermsJeevesComponent,
  SummarizeOrderJeevesComponent
} from 'gung-standard-jeeves';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { ColmecButtonsComponent } from '../components/checkout/colmec-buttons/colmec-buttons.component';
import { ColmecCartTotalStepComponent } from '../components/checkout/colmec-cart-total-step/colmec-cart-total-step.component';
import { ColmecAssignJeevesDefaultsComponent } from '../components/checkout/steps/colmec-assign-jeeves-defaults/colmec-assign-jeeves-defaults.component';
import { ColmecCheckoutStepOrderTermsUserComponent } from '../components/checkout/steps/colmec-checkout-step-order-terms-user/colmec-checkout-step-order-terms-user.component';
import { ColmecCheckoutStepOrderTermsComponent } from '../components/checkout/steps/colmec-checkout-step-order-terms/colmec-checkout-step-order-terms.component';
import { ColmecDeliveryLocationsJeevesComponent } from '../components/checkout/steps/colmec-delivery-locations-jeeves/colmec-delivery-locations-jeeves.component';
import { ColmecSummarizeOrderJeevesComponent } from '../components/checkout/steps/colmec-summarize-order-jeeves/colmec-summarize-order-jeeves.component';
import { ColmecCheckoutStepDubbingComponent } from '../components/colmec-checkout-step-dubbing/colmec-checkout-step-dubbing.component';
@Injectable({
  providedIn: 'root'
})
export class ColmecCheckoutConfigService extends JeevesCheckoutConfigService {
  sideButtons = true;

  getMainProcessSteps(): Observable<Type<CheckoutStepComponent>[]> {
    return super.getMainProcessSteps().pipe(
      map(d => {
        //d.splice(d.indexOf(AssignOrderRowsJeevesComponent), 0, ColmecCheckoutStepDubbingComponent);

        // add email recipient just after the assign order rows
        d.splice(d.indexOf(AssignOrderRowsJeevesComponent) + 1, 0, EmailRecipientComponent);

        if (d.indexOf(CartTotalStepComponent) > -1) {
          d[d.indexOf(CartTotalStepComponent)] = ColmecCartTotalStepComponent;
        }

        if (d.indexOf(DeliveryLocationsJeevesComponent) > -1) {
          d[d.indexOf(DeliveryLocationsJeevesComponent)] = ColmecDeliveryLocationsJeevesComponent;
        }

        if (d.indexOf(OrderTermsJeevesComponent) > -1) {
          d[d.indexOf(OrderTermsJeevesComponent)] = ColmecCheckoutStepOrderTermsComponent;
        } else {
          d.splice(d.indexOf(SummarizeOrderJeevesComponent), 0, ColmecCheckoutStepOrderTermsUserComponent);
        }

        d[d.indexOf(SummarizeOrderJeevesComponent)] = ColmecSummarizeOrderJeevesComponent;
        return d;
      })
    );
  }

  getInternalPreProcessSteps(): Observable<Type<CheckoutStepComponent>[]> {
    return super.getInternalPreProcessSteps().pipe(
      map(d => {
        d[d.indexOf(AssignJeevesDefaultsComponent)] = ColmecAssignJeevesDefaultsComponent;
        return d;
      })
    );
  }

  getButtonsComponent(): Type<ButtonsComponent> {
    return ColmecButtonsComponent;
  }
}
